// สูตรคำนวณคะแนนที่ซ้ำกันในทั้งสองไฟล์ (useEffect ของ groups/EditGroup และ formTwoData)
// คงสูตรเดิมทุกตัวอักษร ห้ามเปลี่ยนลำดับการคูณ/หารหรือ toFixed เพราะกระทบผลลัพธ์ทศนิยม

// ใช้กับ groups / EditGroup (tab 1: ผลสัมฤทธิ์ของงาน) -> (weight * score) / 100 แล้วรวม
export function computeWeightedSum(items) {
  const calculatedValues = items.map(
    item => (item.weight * Number(item.score)) / 100
  );
  return calculatedValues.reduce(
    (accumulator, currentValue) => accumulator + currentValue.toFixed(4) * 1,
    0
  );
}

// ใช้กับ formTwoData (tab 2: พฤติกรรม/สมรรถนะ) -> (score * percentage) / 100 แล้วรวม
export function computeBehaviorSum(formTwoData) {
  const calculatedValues = formTwoData.map(
      (group, index) => (group.score * group.percentage) / 100
    );
    const sum = calculatedValues.reduce(
      (accumulator, currentValue) => accumulator + currentValue.toFixed(4) * 1,
      0
    );

    return sum?.toFixed(4)
}

// แปลง sum ให้เป็นคะแนนเต็ม (sum * (100/5)).toFixed(2) — ใช้ตั้งค่า formTheeData_1.score / formTheeData_2.score
export function toFullScore(sum) {
  return (sum * (100 / 5)).toFixed(4);
}
